import React from 'react';
import { Card } from 'react-bootstrap';
import { StatusMessage } from '../../ui/StatusMessage';

const RealEstateList = ({
    assets = [],
    loading = false,
    error = null,
    onRetry,
    onAssetCardClick,
}) => {
    if (loading) {
        return (
            <StatusMessage
                tone="loading"
                title="Loading real estate listings"
                message="We are loading the latest real estate assets."
            />
        );
    }

    if (error) {
        return (
            <StatusMessage
                tone="error"
                title="Could not load real estate"
                message={error}
                actionLabel={onRetry ? 'Retry' : undefined}
                onAction={onRetry}
            />
        );
    }

    if (assets.length === 0) {
        return (
            <StatusMessage
                tone="empty"
                title="No real estate listings"
                message="There are no active real estate listings available right now."
            />
        );
    }

    return (
        <div className="tyk-grid">
                {assets.map((asset) => (
                        <Card
                            as="button"
                            type="button"
                            onClick={() => onAssetCardClick(asset)}
                            className="card tyk-card h-100 border-0 p-0 text-start text-white"
                            key={asset.id}
                        >
                            <Card.Body className="d-flex h-100 flex-column gap-3 p-3">
                                {asset.imageURL && (
                                    <img
                                        src={asset.imageURL}
                                        alt={asset.assetName}
                                        className="h-48 w-full rounded-xl object-cover"
                                    />
                                )}
                                <div>
                                    <span className="tyk-pill mb-2">Property</span>
                                    <Card.Title className="mb-2 text-xl font-bold">{asset.assetName || 'Untitled listing'}</Card.Title>
                                    <Card.Text className="tyk-clamp-4 text-slate-300">{asset.assetDescription || 'No description has been added yet.'}</Card.Text>
                                </div>
                            </Card.Body>
                        </Card>
                ))}
        </div>
    );
};

export default RealEstateList;
